export const DEFAULT_NOTIFICATION_LIMIT = 30;

export const DATA_SOURCE = Object.freeze({

    FIRESTORE: "firestore",

    LEGACY: "legacy",

});